import React from 'react'

import {
  CatalogBrand,
  PaginatedMenusBrandFilter
} from 'src/apollo/onlineOrdering'
import { t } from 'src/translations'

import { FilterOptionRows } from './FilterOptionRows'
import { FilterVariant, filterName, matchByIdOrName } from '../filterUtils'

export type BrandFilterProps = {
  brands: CatalogBrand[]
  variant: FilterVariant
  hasEntered: boolean
  selectedBrands: PaginatedMenusBrandFilter[]
  handleBrandToggle: (brand: PaginatedMenusBrandFilter) => void
}

export const BrandFilter = ({
  brands,
  variant,
  hasEntered,
  selectedBrands,
  handleBrandToggle
}: BrandFilterProps) => {
  const namedBrands = brands.filter(
    (brand): brand is CatalogBrand => !!brand.id && !!brand.name
  )
  return (
    <FilterOptionRows
      sectionName={t('filters.brand')}
      name={filterName(variant, 'brand')}
      hasEntered={hasEntered}
      values={namedBrands.map((brand) => ({ id: brand.id, name: brand.name }))}
      selectedValues={
        new Set(
          namedBrands
            .filter((brand) =>
              selectedBrands.some((b) => matchByIdOrName(b, brand))
            )
            .map((brand) => brand.id)
        )
      }
      onToggle={(id) => {
        const brand = namedBrands.find((b) => b.id === id)
        if (brand) handleBrandToggle({ id: brand.id, name: brand.name })
      }}
    />
  )
}
